module.exports = __webpack_public_path__ + "static/img/H13_2.8d8c85c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/H13_2.png
// module id = ZwP6
// module chunks = 0